import React from "react"

export const composeUserHighlightedWork = (work) => {
  return work ? (
    <span>
      {work && work.role ? work.role : ""}
      {work && work.role && work.name ? ", " : ""}
      {work && work.name ? work.name : ""}
    </span>
  ) : null
}

export const composeUserHighlightedEducation = (education) => {
    return education ? (
        <span>
            {education && education.name ? education.name : ""}
            {education && education.name && education.role ? ", " : ""}
            {education && education.role ? education.role : ""}
        </span>
    ) : null;
};
